import { isEmpty, isNumber, isNaN } from 'lodash';

export function isBlank(value: unknown): boolean {
  return (isEmpty(value) && !isNumber(value)) || isNaN(value);
}
